import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import { Logo } from '~/source/ui/logo/logo';
import { SplashLayout } from '~/source/ui/splash-layout/splash-layout';
import type { MaintenanceStatus as Props } from './maintenance.page.types';

export const Maintenance: React.FC<Props> = ({ text }) => (
  <SplashLayout>
    <div className="maintenance">
      <div className="maintenance__container">
        <div className="maintenance__card">
          <div className="maintenance__content">
            <Logo elementName="h1" variant="dark" />
            {text.map(entry => (
              <Text elementName="p" key={entry} tight>
                {entry}
              </Text>
            ))}
          </div>
          <div className="maintenance__decoration" />
        </div>
      </div>
    </div>
  </SplashLayout>
);
